import React from 'react';
import Button from './Button';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../API/auth';

export default function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await authService.logout();
    navigate("/login", { replace: true });
  };

  return (
    <div style={{ marginTop: '20px' }}>
      <Button label="Logout" onClick={handleLogout} />
    </div>
  );
}
